import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SquarespaceModelComponent } from './squarespace-model.component';
import { MatDialogModule } from '@angular/material/dialog';
import { AppAnalyticsModule } from '../../directives/app-analytics.module';

@NgModule({
    declarations: [SquarespaceModelComponent],
    imports: [CommonModule, MatDialogModule, AppAnalyticsModule],
    exports: [SquarespaceModelComponent],
})
export class SquarespaceModelModule {}
